import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import teamMemberStyle from "./TeamMember/teamMemberStyle";
import TeamMember from "./TeamMember";

const TeamCarousel = ({ teamMembers }) => {
    const classes = teamMemberStyle();
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        if (currentIndex < teamMembers.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <Box className={classes.mobileCarouselContainer}>
            {/* Left Placeholder or Navigation Button */}
            <Box className={classes.navWrapper}>
                {currentIndex > 0 ? (
                    <IconButton className={`${classes.navButton} ${classes.leftNav}`} onClick={handlePrev}>
                        <ArrowBackIos />
                    </IconButton>
                ) : (
                    <div className={classes.navPlaceholder} />
                )}
            </Box>

            {/* Display the Current Team Member */}
            <Box className={classes.cardWrapper}>
                <TeamMember member={teamMembers[currentIndex]} />
            </Box>

            {/* Right Placeholder or Navigation Button */}
            <Box className={classes.navWrapper}>
                {currentIndex < teamMembers.length - 1 ? (
                    <IconButton className={`${classes.navButton} ${classes.rightNav}`} onClick={handleNext}>
                        <ArrowForwardIos />
                    </IconButton>
                ) : (
                    <div className={classes.navPlaceholder} />
                )}
            </Box>
        </Box>
    );
};
export default TeamCarousel;
